import { SVGProps, Ref, forwardRef } from 'react';

export const GridFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 3.91C.5.925.926.5 3.91.5c2.982 0 3.408.426 3.408 3.41 0 2.982-.426 3.408-3.409 3.408S.5 6.892.5 3.91"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.682 3.91C8.682.925 9.108.5 12.09.5S15.5.926 15.5 3.91c0 2.982-.426 3.408-3.41 3.408-2.982 0-3.408-.426-3.408-3.409"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 12.09c0-2.982.426-3.408 3.41-3.408 2.982 0 3.408.426 3.408 3.409S6.892 15.5 3.91 15.5.5 15.074.5 12.09"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.682 12.09c0-2.982.426-3.408 3.409-3.408s3.409.426 3.409 3.409-.426 3.409-3.41 3.409c-2.982 0-3.408-.426-3.408-3.41"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
GridFilledSize16Glyph.displayName = 'GridFilledSize16Glyph';
